import { MdCheckCircle } from "react-icons/md";
import { Link } from "react-router-dom";

export default function SuccessfullySubscription() {
  return (
    <div className="container my-auto py-4">
      <div className="row">
        <div className="col-11 col-lg-10 mx-auto">
          <div className="d-flex align-items-center justify-content-center my-3">
            <MdCheckCircle size={80} className="text-success" />
          </div>

          <h3 className="text-black text-center">
            Assinatura criada com sucesso!
          </h3>
          <p className="text-center">Agora você é fato. Seja bem-vindo!</p>

          <div className="mx-auto text-center py-3">
            <Link
              to="/dashboard"
              className="btn btn-primary"
              style={{ borderRadius: 15 }}
            >
              Ir para o Feed
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}